import React from 'react';
import { InstoreCategory } from 'containers/instore/types';
import { OtherCategoriesSlider } from './styles';
import { getInstoreCategoryData } from 'utils';
import { InstoreCategoryCard } from 'common/components';

export const OtherMobile = ({
	categories,
	storeName,
}: {
	categories: InstoreCategory[];
	storeName: string;
}) => (
	<OtherCategoriesSlider>
		{categories.map(category => {
			const cardData = getInstoreCategoryData(category, storeName);
			return (
				<InstoreCategoryCard
					key={`category-mobile-${category.name}`}
					type="other"
					{...cardData}
				/>
			);
		})}
	</OtherCategoriesSlider>
);
